export default __webpack_public_path__ + "static/media/bet_ok.e447cfed.svg";